module.exports = __webpack_public_path__ + "img/lg_ring_r_skip_1_1@2x.e35fa5eb.png";